import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@drl/env/environment';
import { Observable } from 'rxjs';

import { AppoinmentDTO } from './models/appoinment-dto.model';
import { CommonResponseAppointmentModel, ResponseModel } from './types';

@Injectable({
  providedIn: 'root',
})
export class AppoinmentService {
  readonly BaseURI = environment.patientApiUrl;
  readonly BaseURITenent = environment.userApiUrl;
  readonly BaseIntURI = environment.externalIntApiUrl;
  readonly BaseURIAUTH = environment.authApiUrl;
  doctorDefaultSet = true;
  patientid: number | null;
  doctorid: number | null;
  appointmentid: number | null;
  appointment;
  description: string | null;

  constructor(private readonly httpClient: HttpClient) { }

  getPatients(): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(this.BaseURI + '/patients');
  }
  getDoctors(body): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(this.BaseURITenent + '/users', {
      params: body,
    });
  }
  doctorAvailability(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/getDoctorAvailability',
      body,
    );
  }
  getAppointmentDetailsById(body): Observable<ResponseModel[]> {
    return this.httpClient.post<ResponseModel[]>(
      this.BaseIntURI + '/appointment/getAppointmentDetailsById',
      body,
    );
  }
  getPatientsDetailsById(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/getPatientDetails',
      body,
    );
  }

  // Prateek

  getPatientDetailsByPatientId(patientFilter): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(
      this.BaseURI + '/patients' + patientFilter,
    );
  }

  getDoctorMeetingDetailsByPatientId(filter): Observable<any> {
    return this.httpClient.get<any>(this.BaseURI + '/appointments' + filter);
  }

  editAppointment(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/editAppointment',
      body,
    );
  }

  saveAppoinment(appointment): Observable<AppoinmentDTO> {
    return this.httpClient.post<AppoinmentDTO>(
      this.BaseURI + '/appointments',
      appointment,
    );
  }

  cancelAppointment(data): Observable<ResponseModel> {
    return this.httpClient.post(
      this.BaseIntURI + '/appointment/cancelAppointmentDetails',
      data,
    );
  }
  checkAvailabilityAppoinment(appointment) {
    return this.httpClient.post(
      this.BaseIntURI + '/appointment/cancelAppointmentDetails',
      appointment,
    );
  }
  getLastAppointment(data): Observable<ResponseModel> {
    return this.httpClient.post(
      this.BaseIntURI + '/appointment/getLastAppointmentDetails',
      data,
    );
  }
  getPatientNote(data, id): Observable<ResponseModel> {
    return this.httpClient.get(
      this.BaseURI + `/appointments/${id}/appointment-notes`,
      {params: data},
    );
  }
  getAvailableTimeslots(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getAvailableTimeslots',
      body,
    );
  }
  getListDeptStatus() {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/getSpecialityStatusList',
      null,
    );
  }
  saveFeedback(feedbackData): Observable<ResponseModel[]> {
    return this.httpClient.post<ResponseModel[]>(
      this.BaseIntURI + '/appointment/rateFeedbackAppointment',
      feedbackData,
    );
  }
  getFeedback(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/getDoctorPatientRatingFeedback',
      body,
    );
  }
  getCaregiver(body): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(
      this.BaseURI + `/caregiver/${body}`,
    );
  }
  //
  getCaregiverByExternalId(body): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(
      this.BaseURI + `/patients/external/${body}`,
    );
  }
  //
  getRetryNotification(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/retryAppointmentConfirmationSent',
      body,
    );
  }
  checkNotification(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/appointmentConfirmationCheck',
      body,
    );
  }
  getJoinCallLink(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getAppointmentLink',
      body,
    );
  }
  getCaregiverGroup(body): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(
      this.BaseURITenent + `/care-groups/${body}`,
    );
  }
  getDateTimeById(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getAppointmentById',
      body,
    );
  }
  getFeedbackRequestParam(body): Observable<CommonResponseAppointmentModel> {
    return this.httpClient.post<CommonResponseAppointmentModel>(
      this.BaseIntURI + '/appointment/getFeedbackRequestParam',
      body,
    );
  }
  getNurshingNotes(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getNursingNote',
      body,
    );
  }
  updateAppointmnent(body): Observable<ResponseModel[]> {
    return this.httpClient.post<ResponseModel[]>(
      this.BaseIntURI + '/appointment/updateAppointmentStatus',
      body,
    );
  }
  saveNurshingNotes(body): Observable<ResponseModel[]> {
    return this.httpClient.post<ResponseModel[]>(
      this.BaseIntURI + '/appointment/addNursingNotes',
      body,
    );
  }
  getAttendeeList(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getAttendeeList',
      body,
    );
  }
  getAlternativeEmailAndMob(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getAlternativeContact',
      body,
    );
  }
  updateAppointmnentEncode(body): Observable<ResponseModel[]> {
    return this.httpClient.post<ResponseModel[]>(
      this.BaseIntURI + '/appointment/updateAppointmentStatusB64',
      body,
    );
  }
  buttonDetails(body): Observable<ResponseModel> {
    return this.httpClient.get<object>(this.BaseURITenent + '/tenant-configs', {
      params: body,
    });
  }
  getOnlineAppoinments(body): Observable<ResponseModel> {
    return this.httpClient.post<object>(
      this.BaseURI + '/online-appointment-details/getOnlineAppointments',
      body,
    );
  }
  getOnlineAppoinmentsUpdateStatus(): Observable<ResponseModel> {
    return this.httpClient.patch<ResponseModel>(
      this.BaseURI + '/online-appointment-details/updateStatus',{},{}
    );
  }
  getOnlineAppoinmentsCount(): Observable<ResponseModel[]> {
    return this.httpClient.get<ResponseModel[]>(
      this.BaseURI + '/online-appointment-details/count',
    );
  }

  getAppointmentStatus(body): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(
      this.BaseIntURI + '/appointment/getApptCurrentStatus',
      body,
    );
  }
  getLoggedInRoleType(): Observable<ResponseModel> {
    return this.httpClient.get<ResponseModel>(
      this.BaseURIAUTH + '/auth/me',
      {},
    );
  }
}
